import type { JSX } from 'react';

import type { PrefetchedUserDataProps } from 'src/shared/prefetch';
import { withPrefetchedData } from 'src/shared/prefetch';

import { MaintenanceBanner } from '../components/MaintenanceBanner';
import { prefetchMaintenanceBanner, useMaintenanceBanner } from '../hooks/maintenanceBanner';

export const MaintenanceBannerContainer = withPrefetchedData(
	({ prefetchedUserData }: PrefetchedUserDataProps<{ maintenanceMessage?: string }>): JSX.Element | null => {
		const maintenanceBannerMessage = useMaintenanceBanner(prefetchedUserData?.maintenanceMessage);

		if (!maintenanceBannerMessage) return null;

		return <MaintenanceBanner message={maintenanceBannerMessage} />;
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchUserData: async (context) => {
			return { maintenanceMessage: await prefetchMaintenanceBanner(context) };
		},
	},
);
